import { render } from 'preact';
import { PortalApp } from './PortalApp';
import './portal.css';

render(<PortalApp />, document.getElementById('portal')!);
